// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3qnQx","title":"Info_title__3xduZ","links":"Info_links__3ookm","link":"Info_link__3wBfE","logo":"Info_logo__2vTXO"};